
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "Layout3",
})
export default class extends Vue {}
